<template>
  <div>
    <button
      @click="prevPage"
      style="
        font-size: 14px;
        text-decoration: none;
        line-height: 30px;
        color: #98c14b;
        display: flex;
        border: 0;
        background: transparent;
      "
    >
      <p>
        <a-icon type="double-left" />
      </p>
      <p>Go Back</p>
    </button>
    <div style="margin-top: 2em">
      <StockCountProducts :counts="singleStock" />
    </div>
  </div>
</template>

<script>
import StockCountProducts from "../tables/StockCountProducts";
export default {
  components: { StockCountProducts },
  methods: {
    prevPage() {
      this.$router.go(-1);
    },
  },
  computed: {
    singleStock() {
      return this.$store.getters["distroCenter/GetSingleStock"];
    },
  },
  watch: {
    singleStock: {
      immediate: true,
      handler: function (stock) {
        // console.log("got here");
        if (Object.keys(stock) < 1 || stock == undefined) {
          this.$router.go(-1);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>